module.exports = __webpack_public_path__ + "static/media/end-screen.ccd87a71.svg";